<div [ngClass]="{ 'hidden-element': showForm}">
    <p-table 
    #tt 
    [value]="contracts" 
    [loading]="showLoader"
    [paginator]="true" 
    [rowsPerPageOptions]="[10,25,50]"
    (onLazyLoad)="onLoadContractLazy($event)"
    [rows]="rowsOnPage" 
    [lazy]="true"
    [(first)]="first"
    [totalRecords]="totalRecords"
    styleClass="ui-table {{ styleClassName }}"
    dataKey="id">
        <ng-template pTemplate="caption" *ngIf="!userId">
            <span style="border-bottom: 3px solid #40499b; padding-bottom: 5px;">{{ 'contracts' | translate }}</span>
            <div *ngIf="'admin' == role" class="caption-dropdown" style="position: absolute; top: 10px; right: 10px;">
                <button type="button" pButton icon="pi pi-sliders-h" (click)="onToggleFilters()" style="min-width: 60px; margin-right: 10px;"></button>
                <p-dropdown [options]="contractStatus" [(ngModel)]="contractSearchParams.status" (onChange)="onSearchContracts()"></p-dropdown>
            </div>
            <div *ngIf="'admin' == role" [hidden]="!showFilters" style="margin-left: -10px; margin-right: -10px;">
                <div class="p-grid ui-fluid" style="padding: 15px 0 0 0; margin: 0; background: #fff">
                    <!-- formularz do wyszukiwania -->
                    <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                        <span class="ui-float-label">
                            <input id="name-input" pInputText [(ngModel)]="contractSearchParams.name" type="text" style="width: 100%;">
                            <label for="name-input">{{ 'name' | translate }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                        <span class="ui-float-label">
                            <input id="surname-input" pInputText [(ngModel)]="contractSearchParams.surname" type="text" style="width: 100%;">
                            <label for="surname-input">{{ 'surname' | translate }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                        <span class="ui-float-label">
                            <p-calendar id="calendar-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [(ngModel)]="contractSearchParams.date_range" selectionMode="range" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" [locale]="calendar_pl"></p-calendar>
                            <label for="calendar-input">{{ 'contract_created_date' | translate }}</label>
                        </span>
                    </div> 
                    <div class="p-col-12 p-sm-6 p-md-6 p-lg-4">
                        <span class="ui-float-label">
                            <p-calendar id="calendar-month-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"[(ngModel)]="contractSearchParams.date_month" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2000:2030" [readonlyInput]="true" [locale]="calendar_pl"></p-calendar>
                            <label for="calendar-month-input">{{ 'contract_month' | translate }}</label>
                        </span>
                    </div>             
                    
                    <div class="p-col-12 p-sm-12 p-md-12 p-lg-12" style="text-align: right;">
                        <button type="button" pButton icon="pi pi-search" (click)="onSearchContracts()" style="min-width: 60px;"></button>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header" class="marmaz">
            <tr class="table-header">
                <th *ngIf="'admin' == role">ID</th>
                <th>{{ 'contract_number' | translate }} </th>
                <th>{{ 'contract_created_date' | translate }} </th>
                <th *ngIf="'admin' == role  && !userId">{{ 'name_and_surname' | translate }}</th>
                <th>{{ 'contract_status' | translate }}</th>
                <th *ngIf="'arranger' == role">{{ 'signed_bills' | translate }}</th> 
                <th *ngIf="'admin' == role">
                    <button type="button" pButton icon="pi pi-refresh" (click)="onRefreshSearch()"></button>
                </th>         
            </tr>        
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td *ngIf="'arranger' == role" [attr.colspan]="4" style="text-align: center;">
                    {{ 'no_data' | translate }}
                </td>
                <td *ngIf="'admin' == role" [attr.colspan]="6" style="text-align: center;">
                    {{ 'no_data' | translate }}
                </td>
            </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-contract let-expanded="expanded">        
            <tr>
                <td *ngIf="'admin' == role">{{contract.id}} </td>
                <td style="cursor: pointer;" (click)="this.downloadContract(contract.id)">{{contract.contract_no}}</td>
                <td>{{contract.contract_date | date: 'dd.MM.yyyy'}}</td>
                <td *ngIf="'admin' == role && !userId">{{contract.name}} {{contract.surname}} {{(contract.b2b ? '(B2B)' : '')}}</td>
                <td *ngIf="contract.status == 'error'">
                    <a href="#" [pRowToggler]="contract" class="status status-error">
                        {{ 'contract_status_error' | translate }}
                        <i [ngClass]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                    </a>            
                </td>
                <td *ngIf="contract.status == 'new'" class="status status-new">{{ 'contract_status_new' | translate }}</td>
                <td *ngIf="contract.status == 'accepted'" class="status status-accepted">{{ 'contract_status_accepted' | translate }}
                    <span *ngIf="contract.attachments?.length > 0 && 'admin' == role" class="status-signed">Dodane załączniki</span>
                </td>
                <td *ngIf="contract.status == 'signed'" class="status status-signed">{{ 'contract_status_signed' | translate }}</td>
                <td style="cursor: pointer;" *ngIf="'arranger' == role" (click)="this.showAttachments(contract.id)">Pokaż</td>
                <td *ngIf="'admin' == role">
                    <p-menu #menu [popup]="true" [model]="functionsMenu" appendTo="body"></p-menu>
                    <button type="button" pButton icon="pi pi-cog" (click)="onPopulateFunctionsMenu($event, contract.id)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-contract>
            <tr>
                <td></td>
                <td [attr.colspan]="4" style="text-align: left;" class="error-line">
                    <div *ngIf="contract.error_data_obj.incorrect.length">
                        <p>{{ 'contract_error_incorrect_fields' | translate }} </p>
                        <ul>
                            <li *ngFor="let incorrect of contract.error_data_obj.incorrect">{{ incorrect | translate }}</li>
                        </ul>                   
                    </div>
                    <div *ngIf="contract.error_data_obj.empty.length">
                        <p>{{ 'contract_error_blank_fields' | translate }} </p>
                        <ul>
                            <li *ngFor="let empty of contract.error_data_obj.empty">{{ empty | translate }}</li>
                        </ul>       
                    </div> 
                </td>
                <td></td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-panel *ngIf="showForm" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px', 'margin-top':'20px'}">
    <p-header>
        <button (click)="onFinishEditing(null)" pButton type="button" label="{{'back_btn' | translate}}" class="ui-button-raised ui-button-info" style="margin-right: 20px;"></button>
        <span class="panel-header">{{ 'contract_edition' | translate }}</span>
    </p-header>
    <div style="margin-top: 20px;">
        <app-contract-form (finishEditing)="onFinishEditing($event)" [contractId]="selectedContractId"></app-contract-form>
    </div>
</p-panel>

<p-confirmDialog #confirmDialog header="{{ 'confirmation' | translate }}">   
     <p-footer>
        <button style="min-width: 60px;" type="button" class="ui-button-success" pButton icon="pi pi-check" (click)="confirmDialog.accept()"></button>
        <button style="min-width: 60px;" type="button" class="ui-button-warning" pButton icon="pi pi-times" (click)="confirmDialog.reject()"></button>
    </p-footer>
</p-confirmDialog>
 
<app-contract-attachments *ngIf="_showAttachments" [contractId]="selectedContractId" [role]="role" (closeModal)="onCloseAttachmentsModal($event)"></app-contract-attachments>